import { useState } from 'react';
import { Avatar, Form } from 'antd';
import styled from 'styled-components';
import { UserOutlined } from '@ant-design/icons';
import { IStaffItemData } from 'services/shop/types/staff';
import InputSearchSuffixIcon from 'components/InputSearchSuffixIcon';

type IStaffSidebarProps = {
  value?: IStaffItemData[];
};

const StaffSidebar = ({ value }: IStaffSidebarProps) => {
  const form = Form.useFormInstance();
  const [text, setText] = useState('');

  const staffListAsFilter = value?.filter((staff) =>
    staff?.firstName?.toLowerCase().includes(text.toLowerCase())
  );

  const handleSelectStaff = (staffChange: IStaffItemData) => () => {
    form.setFieldValue('staffObj', staffChange);
  };

  const staffObj = form.getFieldValue('staffObj');

  return (
    <Container>
      <InputSearchContainer>
        <InputSearchSuffixIcon value={text} onChange={(value) => setText(value)} />
      </InputSearchContainer>

      <StaffListContainer>
        <StaffWrapper>
          {staffListAsFilter?.map((staff) => (
            <StaffItemContainer
              key={staff.id}
              $isSelected={staffObj?.id === staff.id}
              onClick={handleSelectStaff(staff)}
            >
              <StaffItem
                $isSelected={staffObj?.id === staff.id}
                $bgColor={staff?.color || ''}
              >
                <Avatar src={staff.urlImage || ''} size={80} icon={<UserOutlined />} />
                <div className={`name ${staffObj?.id === staff.id ? 'active' : ''}`}>
                  {staff.firstName}
                </div>
              </StaffItem>
            </StaffItemContainer>
          ))}
        </StaffWrapper>
      </StaffListContainer>
    </Container>
  );
};

export default StaffSidebar;

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const InputSearchContainer = styled.div`
  display: flex;
  padding: 24px 16px 16px 16px;
  justify-content: flex-end;
  align-items: center;
  gap: 82px;
  align-self: stretch;
`;

const StaffListContainer = styled.div`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  overflow-y: auto;
  max-height: calc(80vh - 200px);
`;
const StaffWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
`;

const StaffItemContainer = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 4px;
  border: ${({ $isSelected }) => ($isSelected ? '1px solid #d2464f' : '1px solid #adadad')};
  background: ${({ $isSelected }) => ($isSelected ? '#fff1f6' : '#fff')};
  box-shadow: ${({ $isSelected }) => ($isSelected ? '0 0 0 3px rgba(191, 48, 57, 0.15)' : 'none')};
`;
const StaffItem = styled.div<{ $isSelected?: boolean; $bgColor?: string }>`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 4px;
  border: ${({ $isSelected }) => ($isSelected ? '1px solid #adadad' : '')};
  background: ${({ $bgColor }) => $bgColor};
  .name {
    color: #1d2129;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
  }
`;
